import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './public/Home/Home';
import AdminLogin from './admin/AdminLogin/AdminLogin';
import AdminPanel from './admin/AdminPanel/AdminPanel';

try {
  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    document.body.classList.add('safari');
  }
} catch (e) {
  console.error('Error detecting Safari browser:', e);
}

function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef('');

  // listen to location change using useEffect with location as dependency
  // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
  useEffect(() => {
    // console.log('location', location);
    // console.log('lastHash', lastHash.current);
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // save hash for further use after navigation
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document
          .getElementById(lastHash.current)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        lastHash.current = '';
      }, 100);
    }
  }, [location]);

  return null;
}

const App = () => {
  return (
    <Router>
      <ScrollToAnchor />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Home />
            </>
          }
        />
        <Route
          path="/admin-login"
          element={
            <>
              <AdminLogin />
            </>
          }
        />
        <Route
          path="/admin/*"
          element={
            <>
              <AdminPanel />
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;